var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgStarShape = function SvgStarShape(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 28,
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.106 2.018a2.492 2.492 0 0 0-1.909-.126 2.492 2.492 0 0 0-1.439 1.261L10.183 8.37l-5.757.837a2.5 2.5 0 0 0-1.386 4.264l4.166 4.061-.983 5.735a2.5 2.5 0 0 0 3.627 2.635L15 23.195l5.15 2.707a2.5 2.5 0 0 0 3.627-2.635l-.983-5.735 4.166-4.06a2.5 2.5 0 0 0-1.386-4.265l-5.757-.837-2.575-5.217a2.5 2.5 0 0 0-1.136-1.135z",
    fillRule: "evenodd"
  })));
};
export default SvgStarShape;